import React from 'react';
import { Carousel as CarouselAntd } from 'antd';
import styles from '../cms.module.scss';

import Node from '../Node';

const renderNode = ({ Component, ...props }) => (
  <div className={styles['cms-carousel__slide']}>
    <Component {...props} />
  </div>
);

export const Carousel = ({ value: blocs, ...props }) => (
  <section className={styles['cms-carousel']}>
    <CarouselAntd
      autoplay
      autoplaySpeed={5000}
    >
      {blocs.map((bloc, index) => (
        <Node
          {...props}
          key={bloc.id || index}
          blocs={[bloc]}
        >
          {renderNode}
        </Node>
      ))}
    </CarouselAntd>
  </section>
);

export default Carousel;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/Carousel/index.js